import { SET_CHAT_DATA } from '../mutation-types';
const actions = {
    setFooterData: ({ commit }, params) => {
        commit(SET_CHAT_DATA, params);
    },
};
export default actions;
